// extracted by mini-css-extract-plugin
export default {"testName":"resulted-test_testName__IPdPg","testResult":"resulted-test_testResult__fZCuK"};